import { IAppLazyWidget } from 'core-components/sitebuilder/models/IWidgetSelector'

export const lazyWidgets: IAppLazyWidget[] = []
